import { render, staticRenderFns } from "./CbsWidgetHtml.vue?vue&type=template&id=3159e704&scoped=true"
import script from "./CbsWidgetHtml.vue?vue&type=script&lang=js"
export * from "./CbsWidgetHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3159e704",
  null
  
)

export default component.exports